import { Injectable } from '@angular/core';
import type { CommitExchangeResponse } from '../services/interfaces/commit-exchange-response';

@Injectable()
export class PassdataService {
  private exchangeType: string;
  private recombinationDataCache: any;
  private recombinationDataCacheWithoutNullGroup: any;
  private commitExchangeResponse: CommitExchangeResponse;
  private isMinOverride: boolean;
  private isPndIerrOverride: boolean;
  private showEarlyCloseBanner: boolean;
  private emailErrors: any = {};
  private customers: any = null;
  private exchangeConfirmationNumber: number;

  public getExchangeType(): string {
    return this.exchangeType;
  }

  public setExchangeType(value: string) {
    this.exchangeType = value;
  }

  public getExchangeConfirmationNumber(): number {
    return this.exchangeConfirmationNumber;
  }

  public setExchangeConfirmationNumber(value: number) {
    this.exchangeConfirmationNumber = value;
  }

  public getRecombinationDataCache(): any {
    return this.recombinationDataCache;
  }

  public setRecombinationDataCache(value: any) {
    this.recombinationDataCache = value;
  }

  public setRecombinationDataCacheWithoutNullGroup(value: any) {
    this.recombinationDataCacheWithoutNullGroup = value;
  }

  public getRecombinationDataCacheWithoutNullGroup(): any {
    return this.recombinationDataCacheWithoutNullGroup;
  }

  public setCommitExchangeResponse(value: CommitExchangeResponse) {
    this.commitExchangeResponse = value;
  }

  public getCommitExchangeResponse(): CommitExchangeResponse {
    return this.commitExchangeResponse;
  }

  public setMinOverride(value: boolean) {
    this.isMinOverride = value;
  }

  public getMinOverride(): boolean {
    return this.isMinOverride;
  }

  public getPndIerrOverride(): boolean {
    return this.isPndIerrOverride;
  }

  public setPndIerrOverride(value: boolean) {
    this.isPndIerrOverride = value;
  }

  public setEmailErrors(value: any) {
    this.emailErrors = value;
  }

  public getEmailErrors(): any {
    return this.emailErrors;
  }

  public setCustomers(customers: any): void {
    this.customers = customers;
  }

  public getCustomers(): any {
    return this.customers;
  }
}
